import React, { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import MaxDurationShareButton from 'blocks/DownloadPage/components/MaxDurationShareButton';
import { FacebookButton } from 'components/SocialButton';
import useFacebookAuthenticator from 'hooks/useFacebookAuthenticator';
import { videoDurationSecondsSelector } from 'redux/modules/download';
import { hideModal, pushModal } from 'redux/modules/modal';
import { Dispatch } from 'redux/types';
import { createChainedFunction } from 'utils/functions';
import useOnDownloadPageAction from '../useOnDownloadPageAction';

const MAX_VIDEO_DURATION_SEC = 36000; // 10 hours

const FacebookPostButton: React.FC = () => {
  const [shouldReauthenticate, setShouldReauthenticate] = useState<boolean>(
    false,
  );

  const videoDurationSec = useSelector(videoDurationSecondsSelector);

  const { onDownloadPageAction } = useOnDownloadPageAction();
  const dispatch = useDispatch<Dispatch>();

  const handleError = useCallback(() => {
    setShouldReauthenticate(true);
    dispatch(hideModal());
  }, [dispatch]);

  const { authenticating, withAuthentication } = useFacebookAuthenticator({
    force: shouldReauthenticate,
    onError: handleError,
  });

  const openSocialShareModal = useCallback(() => {
    dispatch(
      pushModal({
        name: 'SocialShare',
        params: {
          platform: 'facebook',
        },
      }),
    );
  }, [dispatch]);

  return (
    <MaxDurationShareButton
      platform="facebook"
      videoDurationSec={videoDurationSec}
      maxVideoDurationSec={MAX_VIDEO_DURATION_SEC}
    >
      <FacebookButton
        size="small"
        params={withAuthentication}
        disabled={authenticating}
        onClick={createChainedFunction(
          () => onDownloadPageAction('facebookShare'),
          withAuthentication(openSocialShareModal),
        )}
      />
    </MaxDurationShareButton>
  );
};

export default FacebookPostButton;
